import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 1rem 0;
  :last-child {
    margin-bottom: 0px;
  }
`;

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  fill: ${({ theme: { colors } }) => colors.primary.main};
  margin-right: 8px;
`;
